import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-accessibility-dialog',
  templateUrl: './accessibility-dialog.component.html',
  styleUrls: ['./accessibility-dialog.component.scss']
})
export class AccessibilityDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<AccessibilityDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Inject(DOCUMENT) private document: Document,
              private dialog: MatDialog,
              public device: DeviceDetectorService) { }

  ngOnInit() {
  }

  onToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      this.document.body.classList.add('bw');
    } else {
      this.document.body.classList.remove('bw');
    }
  }

  onFontSizeChange(value: number) {
    debugger;
  }
}
